export const APP_VERSION = "1.0.0";
export const APP_NAME = "Isocronas";
export const APP_NAME_LONG = "Isocronas";
export const APP_LOGO_PATH = "/logo/logo_main.png";
export const APP_LOGO_LOGIN_PATH = "/logo/logo_login.png";
export const APP_LOGO_URL = "https://www.dipalme.org/";
